import { isQuotaFissa, isTotalizzatore } from 'features/ippica/functions';
import {
  selectCurrentScommesseType,
  selectHeadersQuotaFissaList,
  selectKeyListQuotaFissaResults,
  selectKeyListQuoteTotalizzatore,
  selectKeyListQuoteVincentiResults,
  selectListQuotePiazzato,
} from 'features/ippica/selectors';

import { IppicaScommesseEsitoTipoBoxChiuso } from '../../ippicaScommesseEsitoTipoBoxChiuso';
import { IppicaScommesseEsitoTipoBoxChiusoMinMax } from '../../ippicaScommesseEsitoTipoBoxChiuso/IppicaScommesseEsitoTipoBoxChiuso';
import React from 'react';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaScommesseEsitoResultsRendererProps = {
  keyCavallo: string;
};
export const IppicaScommesseEsitoResultsRenderer = ({ keyCavallo }: IppicaScommesseEsitoResultsRendererProps) => {
  const currentTypeScommessa = useTypedSelector(selectCurrentScommesseType);

  const quoteKeyListQuotaFissa = useTypedSelector(selectKeyListQuotaFissaResults(keyCavallo));
  const quoteKeyListTotalizzatore = useTypedSelector(selectKeyListQuoteTotalizzatore(keyCavallo));
  const quoteKeyListVincente = useTypedSelector(
    selectKeyListQuoteVincentiResults(quoteKeyListTotalizzatore, keyCavallo)
  );
  const quoteListPiazzato = useTypedSelector(selectListQuotePiazzato(quoteKeyListTotalizzatore, keyCavallo));
  const headerQuotaFissaList = useTypedSelector(selectHeadersQuotaFissaList);
  return (
    <React.Fragment>
      {isQuotaFissa(currentTypeScommessa!)
        ? quoteKeyListQuotaFissa.map((keyQuota, indexQuota) => {
            return (
              <IppicaScommesseEsitoTipoBoxChiuso
                key={keyQuota}
                label={headerQuotaFissaList?.[indexQuota]?.label}
                keyCavallo={keyCavallo}
                keyQuota={keyQuota}
              />
            );
          })
        : null}
      {isTotalizzatore(currentTypeScommessa!) ? (
        <>
          <IppicaScommesseEsitoTipoBoxChiuso
            label={'vincente'}
            keyCavallo={keyCavallo}
            keyQuota={quoteKeyListVincente?.[0] ?? ''}
          />
          <IppicaScommesseEsitoTipoBoxChiusoMinMax
            label={'quota piazzato'}
            quotaCombinataStatica={quoteListPiazzato[0]?.quota?.toString() ?? '-'}
            keyCavallo={keyCavallo}
          />
        </>
      ) : null}
    </React.Fragment>
  );
};
